import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ExpandablePanel from '../../components/controls/ExpandablePanel'

export default function ObowiazekBadania({ data, onSetSectionData }) {
  return (
    <ExpandablePanel title="OBOWIĄZEK BADANIA">
      <form autoComplete="off" className="obowiazekBadania">
        <FormControlLabel
          className="checkboxLabel high-caption"
          control={
            <Checkbox
              name="ObowiazekBadania"
              color="primary"
              defaultChecked={data.ObowiazekBadania}
              onChange={(e) =>
                onSetSectionData('ObowiazekBadania', e.target.checked)
              }
            />
          }
          label="Sprawozdanie podlega wynikającemu z przepisów prawa obowiązkowi badania przez biegłego rewidenta"
        />
      </form>
    </ExpandablePanel>
  )
}
